// src/features/account/profileConfig.js
//
// `sensitive: true` marks fields that are:
//   - Always masked in the UI
//   - Never prefilled in the edit input (starts empty)
//   - The helper text shows the masked value while editing
//   - Only revealed via step-up auth (POST /api/users/me/reveal)

export const FIELD_CONFIG = {
  firstName:   { label: "First name",   placeholder: "Juan",                   inputMode: "text",    maxLen: 40 },
  lastName:    { label: "Last name",    placeholder: "Dela Cruz",               inputMode: "text",    maxLen: 40 },
  username:    { label: "Username",     placeholder: "juan.delacruz",           inputMode: "text",    maxLen: 20 },
  email:       { label: "Email",        placeholder: "Enter new email address", inputMode: "email",   maxLen: 80, type: "email", sensitive: true },
  phone:       { label: "Phone",        placeholder: "09XXXXXXXXX or +63...",   inputMode: "tel",     maxLen: 13, type: "tel",   sensitive: true },
  birthdate:   { label: "Birthdate",    placeholder: "YYYY-MM-DD",              inputMode: "date",    maxLen: 10, type: "date",  sensitive: true },
  gender:      {
    label: "Gender",
    placeholder: "Select gender",
    type: "select",
    editable: true,
    options: [
      { value: "MALE", label: "Male" },
      { value: "FEMALE", label: "Female" },
      { value: "OTHER", label: "Other" },
    ],
  },
  addressLine1:{ label: "Address line 1", placeholder: "House no., street, barangay", inputMode: "text", maxLen: 120 },
  addressLine2:{ label: "Address line 2", placeholder: "Unit / building (optional)",  inputMode: "text", maxLen: 120 },
  city:        { label: "City",         placeholder: "Bacoor",                  inputMode: "text",    maxLen: 60 },
  province:    { label: "Province",     placeholder: "Cavite",                  inputMode: "text",    maxLen: 60 },
  postalCode:  { label: "Postal code",  placeholder: "4100",                    inputMode: "numeric", maxLen: 6 },
};
